import Store from "./Store";
import {LocalStorage} from "@/app";

function getBooleanFromStorage(key: string): boolean
{
    return LocalStorage.getItem(key) === "true";
}

export default {
    getAccessToken(state: Store): string
    {
        return state.token
            ? state.token.accessToken
            : "";
    },
    getEnv(state: Store): string
    {
        return state.env || LocalStorage.getItem("env");
    },
    getEnvType(state: Store): string
    {
        return state.envType || LocalStorage.getItem("envType");
    },
    getEnvBrand(state: Store): string
    {
        return LocalStorage.getItem("envBrand");
    },
    getFinancedSubjectType(state: Store): string
    {
        return state.financedSubjectType || LocalStorage.getItem("financedSubjectType");
    },
    getClientType(state: Store): string
    {
        return state.clientType || LocalStorage.getItem("clientType");
    },
    getOrderType(state: Store): string
    {
        return state.orderType || LocalStorage.getItem("orderType");
    },
    getFinancingType(state: Store): string
    {
        return state.financingType || LocalStorage.getItem("financingType");
    },
    getCashFinancingType(state: Store): string
    {
        return state.cashFinancingType || LocalStorage.getItem("cashFinancingType");
    },
    getShowQrCode(state: Store): boolean
    {
        return typeof state.showQrCode === "boolean"
            ? state.showQrCode
            : getBooleanFromStorage("showQrCode");
    },
    getCopyToClipboard(state: Store): boolean
    {
        return typeof state.copyToClipboard === "boolean"
            ? state.copyToClipboard
            : getBooleanFromStorage("copyToClipboard");
    },
    getWalletWithOrder(state: Store): string
    {
        return state.walletWithOrder || LocalStorage.getItem("walletWithOrder");
    },
};
